<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const { t } = useI18n();
const dialogRef = ref(null);

const rows = computed(() =>
  [
    'ASSIGNED_TO_YOU',
    'PARTICIPATING',
    'TEAM_PENDING',
    'TEAM_UNASSIGNED',
    'BOT_TO_TEAM',
    'ASSIGNED_TO_OTHER_AGENT',
    'ASSIGNED_TO_OTHER_AGENT_RESTRICTED',
    'OTHER_TEAM',
    'NO_TEAM_OR_ASSIGNEE',
    'RESOLVED',
  ].map(key => ({
    key,
    situation: t(`CHAT_LIST.VISIBILITY_MANUAL.ROWS.${key}.SITUATION`),
    visible: t(`CHAT_LIST.VISIBILITY_MANUAL.ROWS.${key}.VISIBLE`),
    note: t(`CHAT_LIST.VISIBILITY_MANUAL.ROWS.${key}.NOTE`),
  }))
);

const open = () => {
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    width="3xl"
    :show-cancel-button="false"
    :show-confirm-button="false"
  >
    <template #title>
      {{ t('CHAT_LIST.VISIBILITY_MANUAL.TITLE') }}
    </template>

    <template #description>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('CHAT_LIST.VISIBILITY_MANUAL.DESCRIPTION') }}
      </p>
    </template>

    <div class="overflow-x-auto">
      <table class="min-w-full text-sm border-separate border-spacing-0">
        <thead>
          <tr>
            <th
              class="px-3 py-2 text-left text-xs font-medium uppercase text-n-slate-11 bg-n-alpha-1"
            >
              {{ t('CHAT_LIST.VISIBILITY_MANUAL.COLUMNS.SITUATION') }}
            </th>
            <th
              class="px-3 py-2 text-left text-xs font-medium uppercase text-n-slate-11 bg-n-alpha-1"
            >
              {{ t('CHAT_LIST.VISIBILITY_MANUAL.COLUMNS.VISIBLE') }}
            </th>
            <th
              class="px-3 py-2 text-left text-xs font-medium uppercase text-n-slate-11 bg-n-alpha-1"
            >
              {{ t('CHAT_LIST.VISIBILITY_MANUAL.COLUMNS.NOTE') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.key" class="align-top">
            <td class="px-3 py-3 border-b border-n-weak text-n-slate-12">
              {{ row.situation }}
            </td>
            <td
              class="px-3 py-3 border-b border-n-weak text-n-slate-12 whitespace-nowrap"
            >
              {{ row.visible }}
            </td>
            <td class="px-3 py-3 border-b border-n-weak text-n-slate-11">
              {{ row.note }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="mb-0 text-sm text-n-slate-11">
      {{ t('CHAT_LIST.VISIBILITY_MANUAL.NOTE') }}
    </p>
  </Dialog>
</template>
